// extracted by mini-css-extract-plugin
export default {"text-editor":"styles_text-editor__5as23","ql-editor":"styles_ql-editor__Fmx9V"};